import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dropzone from 'react-dropzone';

const UploadModal = ({
  activeModal,
  dropzoneActive,
  isLoading,
  disableClick,
  onClose,
  onDrop,
  onDragEnter,
  onDragLeave,
  dropzoneRef,
  handleSelectedFile,
}) => {
  return (
    <section className="ModalMaster">
      {/* Upload Step */}
      <section className={classNames('Modal Modal__upload Modal__upload__one', { 
        active: activeModal === 1 
      })}>
        <div onClick={() => onClose(0)} className="Modal__layer" role="button" aria-hidden />
        <section className="Modal__wrapper">
          {isLoading && <i className="fa fa-spinner fa-spin fa-3x fa-fw" />}
          {!isLoading && (
            <React.Fragment>
              <div className={classNames('Modal__upload__border', { active: dropzoneActive })} />
              <div
                className="Modal__close-btn"
                style={{ display: dropzoneActive ? 'none' : 'block' }}
                onClick={() => onClose(0)}
                role="button"
                aria-hidden
              />
              <Dropzone
                ref={dropzoneRef}
                disableClick={disableClick}
                className="Modal__upload__content"
                onDrop={onDrop}
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                disablePreview={false}
                multiple={false}
                accept={['.jpg', '.png']}
                inputProps={{ id: 'file' }}
              >
                <div className="Modal__upload__image" />
                <div className="Modal__upload__title">
                  Drag and drop the image here
                </div>
                <div className="Modal__upload__or">Or</div>
                <div className="Modal__upload__action">
                  <input 
                    type="file" 
                    name="file" 
                    id="file" 
                    className="inputFile" 
                    onChange={handleSelectedFile} 
                  />
                  <button className="cta__button">Choose a file</button>
                </div>
                <div className="Modal__upload__or">
                  Mandatory Size: Less than 500kb <br />
                  Recommended Dimensions: 320px (wide) x 320px or less (high)
                </div>
              </Dropzone>
            </React.Fragment>
          )}
        </section>
      </section>

      {/* Loading Step */}
      <section className={classNames('Modal Modal__upload Modal__upload__two', { 
        active: activeModal === 2 
      })}>
        <div onClick={() => onClose(0)} className="Modal__layer" role="button" aria-hidden />
        <section className="Modal__wrapper">
          <div className="Modal__upload__border" />
          <div onClick={() => onClose(0)} className="Modal__close-btn" role="button" aria-hidden />
          <section className="Modal__upload__content">
            <div className="Modal__upload__image" />
            <div className="Modal__upload__title">Uploading the image</div>
            <div className="Modal__upload__loading">
              <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
            </div>
          </section>
        </section>
      </section>

      {/* Success Step */}
      <section className={classNames('Modal Modal__upload Modal__upload__three', { 
        active: activeModal === 3 
      })}>
        <div onClick={() => onClose(0)} className="Modal__layer" role="button" aria-hidden />
        <section className="Modal__wrapper">
          <div onClick={() => onClose(0)} className="Modal__close-btn" role="button" aria-hidden />
          <section className="Modal__upload__content">
            <section className="Modal__upload__avatar">
              <div className="Modal__upload__avatar--container" aria-hidden />
            </section>
            <div className="Modal__upload__title2">Upload completed</div>
            <div onClick={() => onClose(0)} className="Modal__upload__button" aria-hidden>
              Change Image
            </div>
          </section>
        </section>
      </section>
    </section>
  );
};

UploadModal.propTypes = {
  activeModal: PropTypes.number.isRequired,
  dropzoneActive: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  disableClick: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  onDragEnter: PropTypes.func.isRequired,
  onDragLeave: PropTypes.func.isRequired,
  dropzoneRef: PropTypes.func,
  handleSelectedFile: PropTypes.func.isRequired,
};

export default UploadModal;